/** Deterministic stunt animation. No third-party physics or frame-rate dependent timers. */
export interface CrashState {
  time: number; duration: number; speed: number; direction: number; flight: number;
  impact: boolean; respawnDistance: number; respawnLateral: number;
}
export function crashPose(c: CrashState) {
  const t = Math.min(c.time, c.flight), landed = c.time >= c.flight;
  const slide = Math.min(.8, Math.max(0, c.time - c.flight));
  return {
    forward: c.speed * .24 * t + slide * c.speed * .07,
    sideways: c.direction * (t * 1.25 + slide * .7),
    height: Math.max(0, 4.905 * t * (c.flight - t)),
    tumble: landed ? Math.PI * 2.5 : Math.PI * 2.5 * t / c.flight,
    impactPulse: landed ? Math.max(0, 1 - slide * 3) : 0,
    landed,
  };
}
